import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StudentRoutingModule } from './student-routing.module';
import { AgmCoreModule } from '@agm/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { ChartistModule } from 'ng-chartist';
import { NgxMaskModule } from 'ngx-mask';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { CertificateComponent } from './certificate/certificate.component';
import { StudentOnboardingComponent } from './student-onboarding/student-onboarding.component';
import { ArchwizardModule } from 'angular-archwizard';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MainDashboardComponent } from './main-dashboard/main-dashboard.component';
import { StudentEnrollmentComponent } from './student-enrollment/student-enrollment.component';
import { NgxSpinnerModule } from 'ngx-spinner';


@NgModule({
  declarations: [
    CertificateComponent,
    StudentOnboardingComponent,
    MainDashboardComponent,
    StudentEnrollmentComponent
  ],
  imports: [
    CommonModule,
    StudentRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ChartistModule,
    AgmCoreModule,
    NgSelectModule,
    NgbModule,
    SwiperModule,
    PipeModule,
    NgxDatatableModule,    
    NgxMaskModule.forRoot(),
    ArchwizardModule,
    MatSlideToggleModule,
    NgxSpinnerModule
  ],
  providers: [
    NgbActiveModal,  // Ensure NgbActiveModal is provided here
  ],
})
export class StudentModule { }
